module.exports = __webpack_public_path__ + "img/jo.6476ad0b.svg";